import { render } from "./DataTablePage.vue?vue&type=template&id=a3361682&ts=true"
import script from "./DataTablePage.vue?vue&type=script&lang=ts"
export * from "./DataTablePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__